import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToModuleState,
  type ModuleState,
  type ModuleStateApiResource,
} from './modulesApi.types';

export async function fetchTenantModules(tenantId: string): Promise<ModuleState[]> {
  const response = await httpClient.get<ModuleStateApiResource[]>(
    '/tenants/' + tenantId + '/modules'
  );
  return response.data.map(mapApiResourceToModuleState);
}

export async function setTenantModule(
  tenantId: string,
  moduleKey: string,
  isEnabled: boolean
): Promise<ModuleState> {
  const response = await httpClient.patch<ModuleStateApiResource>(
    '/tenants/' + tenantId + '/modules/' + moduleKey,
    { is_enabled: isEnabled }
  );
  return mapApiResourceToModuleState(response.data);
}
